import React from "react";
import { AttachmentInfo } from "@eres/ejari-api/Entity/tenant";
import { getLocalValue } from "@eres/core/dist/LocaleValue";

interface Props {
	docId: number;
	documents?: AttachmentInfo[];
	onDelete: ( docId: number, index: number ) => void;
}

export function RenderManagementContractDocs( props: Props ) {
	const { documents, docId, onDelete } = props;
	if ( documents && documents.length > 0 ) {
		return <>
			{ documents.map( ( doc, index ) => {
				const lookupName = getLocalValue( { en: doc.DocumentNameEn, ar: doc.DocumentNameAr } );
				return <div key={ `${ doc.DocumentID }_${ index }` }>
					<span>{ lookupName }</span>
					<span>
                        <React.Fragment key={ doc.FileName }>
                            <span className="attach-doc-span flex-row align-items-center justify-content-between">
	                            <a
		                            href="#" className="underline"
		                            onClick={ e => {
			                            e.preventDefault();
			                            const pdfResult = doc.LocalData;
			                            const pdfWindow = window.open( "" );
			                            pdfWindow?.document.write( "<iframe width='100%' height='100%' src='" + encodeURI( pdfResult + "" ) + "'></iframe>" );
		                            } }>
	                                { doc.FileName }
								</a>
	                            <button className="btn btn-grey" onClick={ () => onDelete( docId, index ) }>
									<i className="far fa-trash-alt"/>
								</button>
							</span>
                        </React.Fragment>
					</span>
				</div>;
			} )
			}
		</>;
	}
	return null;
}